import {
  currencyFormatter,
  transformPenniesToDollar,
} from 'src/utilities/currency-utils';

export function formatPenniesToCurrency(value: number): string {
  return currencyFormatter(Number(transformPenniesToDollar(value)));
}
